import angular from 'angular';
import { TipoSolicitacaoEnum } from '../../../../shared/enums/TipoSolicitacaoEnum';
import { Usuario } from '../../../../core/usuario/models/usuario-model';
import { IContribuinteIndividualCreate, IContribuinteIndividualGet } from '../model/contribuintesindividuais.model';
import { IAnexo } from '../../Anexos/models/anexo.model';
import { MeurhContribuintesIndividuaisService } from '../contribuintesindividuais.service';
import { TiposDocumentosRequeridosService } from '../../../Tiposdocumentosrequeridos/tiposdocumentosrequeridos.service';

export class MeurhContribuintesIndividuaisNewController {

    static $inject = [
        '$rootScope',
        '$scope',
        '$state',
        'MeurhContribuintesIndividuaisService',
        'TiposDocumentosRequeridosService',
        'NewToaster',
    ];

    public form: angular.IFormController;
    public entity: IContribuinteIndividualGet = {} as IContribuinteIndividualGet;
    public busy = false;

    public formAnexo: angular.IFormController;
    public tiposdocumentosrequeridos: any[];
    public entityAnexo: IAnexo = {
        casodeuso: 'CONTRIBUINTEINDIVIDUAL'
    };
    public busyTipoDocumentos = false;

    constructor(
        public $rootScope: angular.IRootScopeService & {
            temPermissao: (arg: string) => boolean,
            liberadoTela: (arg: string) => boolean,
            usuario: Usuario,
            configuracoes: any,
            session: any,
        },
        public $scope: angular.IScope,
        public $state: angular.ui.IStateService,
        public MeurhContribuintesIndividuaisService: MeurhContribuintesIndividuaisService,
        public TiposDocumentosRequeridosService: TiposDocumentosRequeridosService,
        public NewToaster: { pop: Function },
    ) {
        if (
            !this.$rootScope.temPermissao('criar_contribuinte') ||
            !$rootScope.liberadoTela('LIBERAR_SOLICITACAO_CONTRATACAO_CONTRIBUINTE') ||
            !$rootScope.configuracoes.PARAMETROS_CONTRATACAO_AUTONOMOS
        ) {
            $state.go('dp');
        }

        this.entity.estabelecimento = this.$rootScope.session.entities.estabelecimento;
        this.entity.unidadesalariofixo = '4';

        this.carregaTiposDocumentosRequeridos();

        $scope.$on('meurh_solicitacoescontratacaocontribuinte_create_loaded', (event, args: IContribuinteIndividualGet) => {
            if (this.tiposdocumentosrequeridos.length <= 0) {
                this.NewToaster.pop({
                    type: 'success',
                    title: 'A solicitação de inclusão de autônomo foi criada',
                    body: 'A solicitação de inclusão de autônomo foi criada com sucesso.'
                });
                this.$state.go('meurh_contribuintesindividuais_show', {
                    'solicitacao': args.solicitacao
                });
            } else {
                this.entityAnexo['solicitacao'] = args.solicitacao;
                this.$rootScope.$broadcast('meurh_todas_solicitacoes_submitted', {});

                this.$scope.$on('meurh_todas_solicitacoes_documentos_complete', () => {
                    this.$scope.$apply(); // para atualizar os valores dos validateResult vindos do componente anexo
                    if (this.tiposdocumentosrequeridos.every((tipodocumentorequerido) => tipodocumentorequerido.validateResult)) {
                        this.NewToaster.pop({
                            type: 'success',
                            title: 'A solicitação de inclusão de autônomo foi criada',
                            body: 'A solicitação de inclusão de autônomo foi criada com sucesso.'
                        });
                        this.$state.go('meurh_contribuintesindividuais_show', {
                            'solicitacao': args.solicitacao
                        });
                    }
                });
            }
        });

        $scope.$on('meurh_tiposdocumentosrequeridos_list_finished', () => {
			this.busyTipoDocumentos = false;
			this.tiposdocumentosrequeridos = this.tiposdocumentosrequeridos.map((tipodocumentorequerido) => {
				tipodocumentorequerido.validateResult = false;
				tipodocumentorequerido.fileSelecionado = false;
				return tipodocumentorequerido;
			});
		});

        $scope.$on('meurh_solicitacoescontratacaocontribuinte_create_error', (event, args: any) => {
            this.busy = false;
			let error = `Ocorreu um erro ao criar a solicitação de inclusão de autônomo.`;
            if (args.data?.message) {
                error = args.data.message;
            }
            this.NewToaster.pop({
                type: 'error',
                title: error
            });
		});
    }

    submit() {
        this.form.$submitted = true;

        if (this.form.$invalid) {
            return;
        }

        const docsValid = this.tiposdocumentosrequeridos.every((tipodocumentorequerido) => {
			return (
				tipodocumentorequerido.fileSelecionado === tipodocumentorequerido.obrigatorio ||
				tipodocumentorequerido.fileSelecionado
			);
		});

        if (!docsValid) {
            this.NewToaster.pop({
                type: 'error',
                title: 'Há documento(s) obrigatório(s) não informado(s)'
            });
            return;
        }

        this.busy = true;
        this.MeurhContribuintesIndividuaisService.createContratacaoContribuinte(this.setRequestBody());
    }

    setRequestBody(): IContribuinteIndividualCreate {
        return {
            subtipo: 0,
            situacao: 0,
            nome: this.entity.nome,
            cpf: this.entity.cpf,
            datanascimento: this.entity.datanascimento,
            datainicioprestacao: this.entity.datainicioprestacao,
            categoriatrabalhador: this.entity.categoriatrabalhador,
            estabelecimento: this.entity.estabelecimento.estabelecimento,
            departamento: this.entity.departamento?.departamento ?? null,
            lotacao: this.entity.lotacao.lotacao,
            semdadosbancarios: this.entity.semdadosbancarios,
            tiporecebimento: this.entity.tiporecebimento!,
            banco: this.entity.banco?.banco ?? null,
            agencianumero: this.entity.agencianumero ?? null,
            agencianumerodv: this.entity.agencianumerodv ?? null,
            numeroconta: this.entity.numeroconta ?? null,
            numerocontadv: this.entity.numerocontadv ?? null,
            chavepix: this.entity.chavepix ?? null,
            tipocontapix: this.entity.tipocontapix ?? null,
            unidadesalariofixo: this.entity.unidadesalariofixo,
            matricula: this.entity.matricula
        };
    }

    carregaTiposDocumentosRequeridos() {
        this.busyTipoDocumentos = true;
        this.resetTiposDocumentosRequeridosService();
        this.TiposDocumentosRequeridosService.constructors = {
            tiposolicitacao: TipoSolicitacaoEnum.CONTRIBUINTE_INDIVIDUAL
        };
        this.tiposdocumentosrequeridos = this.TiposDocumentosRequeridosService.load();
    }

    resetTiposDocumentosRequeridosService() {
        this.tiposdocumentosrequeridos = [];
        this.TiposDocumentosRequeridosService.entities = [];
        this.TiposDocumentosRequeridosService.loadParams = {
            to_load: 3,
            busy: false,
            finished: false
        };
        this.TiposDocumentosRequeridosService.after = {};
    }
}
